export default {
  getTasks: (state) => state.tasks,
  getTask: (state) => (id) => {
    return state.tasks.find(task => task.id === parseInt(id))
  },
  getEmptyTask: (state) => JSON.parse(JSON.stringify(state.emptyTask)),
}